import React from "react";
import cx from "classnames";
import { faCheck, faFlagCheckered } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconContainer } from "../iconContainer";

export const AccountSeparatorIcon = ({ arrears, className }) => (
  <IconContainer className={cx("account-separator-icon", className, { "red-background": arrears })}>
    <FontAwesomeIcon
      icon={arrears ? faFlagCheckered : faCheck}
      color="#fff"
    />
  </IconContainer>
);

export function AccountSeparator({ arrears }) {
  return (
    <div className="account-separator display-flex mtn-5">
      <div className="separator" />
      <AccountSeparatorIcon className="hide-desktop" arrears={arrears} />
    </div>
  );
}
